import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    makeStyles
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
    dialog: {
        minWidth: 400
    }
}));

const AppointmentSettingsModal = ({ open, onClose }) => {
    const classes = useStyles();
    const [hoursBeforeConfirmation, setHoursBeforeConfirmation] = useState(24);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            fetchSettings();
        }
    }, [open]);

    const fetchSettings = async () => {
        try {
            const { data } = await api.get("/appointment-settings");
            setHoursBeforeConfirmation(data.hoursBeforeConfirmation || 24);
        } catch (err) {
            console.error("Error fetching settings:", err);
        }
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            await api.put("/appointment-settings", {
                hoursBeforeConfirmation: parseInt(hoursBeforeConfirmation, 10)
            });
            toast.success("Configurações salvas com sucesso!");
            onClose();
        } catch (err) {
            toast.error("Erro ao salvar configurações");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ style: { boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)' } }}>
            <DialogTitle>Configurações de Confirmação</DialogTitle>
            <DialogContent>
                <TextField
                    label="Horas antes do agendamento para enviar confirmação"
                    type="number"
                    fullWidth
                    value={hoursBeforeConfirmation}
                    onChange={(e) => setHoursBeforeConfirmation(e.target.value)}
                    margin="normal"
                    helperText="Ex: 24 horas = envia confirmação 1 dia antes"
                    inputProps={{ min: 1, max: 168 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="default">
                    Cancelar
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AppointmentSettingsModal;
